<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <!--산업안전보건위원회 회의록 기본정보-->
          <c-card title="LBL0010201" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-appr-btn 
                  v-if="!isApprDisabled && showApproval && isOwner"
                  ref="appr-btn"
                  name="danger-journal-appr-btn"
                  :editable="editable"
                  :approvalInfo="approvalInfo"
                  @beforeApprAction="saveDataAppr"
                  @callbackApprAction="approvalCallback"
                  @requestAfterAction="getDetail"
                />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <!--회의제목-->
                <c-text
                  required
                  :editable="editable"
                  :disabled="true"
                  label="LBL0010198"
                  name="proceedingsTitle"
                  v-model="opinions.proceedingsTitle">
                </c-text>
              </div>
              <!--회의일-->
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-datepicker
                  required
                  :editable="editable"
                  :disabled="true"
                  label="LBL0010199"
                  name="proceedingsDate"
                  v-model="opinions.proceedingsDate">
                </c-datepicker>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-plant
                  required
                  :editable="editable"
                  :disabled="true"
                  type="edit"
                  name="plantCd"
                  v-model="opinions.plantCd">
                </c-plant>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-dept
                  :required="true"
                  :disabled="true"
                  :editable="editable"
                  label="작성부서"
                  name="deptCd"
                  v-model="opinions.deptCd">
                </c-dept>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-datepicker
                  :required="true"
                  :disabled="true"
                  label="의견접수 마감일"
                  name="opinionDt"
                  v-model="opinions.opinionDt">
                </c-datepicker>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <!--회의내용-->
                <c-textarea
                  :editable="editable"
                  :disabled="true"
                  :rows="2"
                  label="LBL0010202"
                  name="proceedingsContents"
                  v-model="opinions.proceedingsContents">
                </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <c-table
                  ref="table"
                  title="참석자 의견"
                  :columns="grid.columns"
                  :data="opinions.opinionlist"
                  gridHeightAuto
                  :merge="grid.merge"
                  :editable="editable&&!disabled && !isOwner"
                  :isExcelDown="false"
                  :columnSetting="false"
                >
                </c-table>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 q-mt-lg">
                <c-upload 
                  :attachInfo="attachInfo"
                  :editable="editable && !isAttend">
                </c-upload>
              </div>
            </template>
          </c-card>
        </div>
      </div>
      <c-dialog :param="popupOptions"></c-dialog>
    </q-form>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'proceedings-detail',
  props: {
    param: {
      type: Object,
      default: () => ({
        proceedingsId: '',
        proceedingStatusCd: '',
      }),
    },
    isApprDisabled: {
      type: Boolean,
      default: false
    },
    contentHeight: null,
  },
  data() {
    return {
      attachable: false,
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'OSH_PROCEEDINGS_OPI',
        taskKey: '',
      },
      saveUrl: transactionConfig.sai.osh.proceedings.insert.url,
      mappingType: 'POST',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      revlistUrl: '',
      editable: true,
      isSave: false,
      isApproval: false,
      isdelete: false,
      opinions: {
        proceedingsId: '',
        plantCd: '',
        proceedingsDate: '',
        proceedingsContents: '',
        proceedingsAttendeeId: '',
        proceedingsTitle: '',
        regUserId: '',
        chgUserId: '',
        deptCd: '',
        attendeeCoModels: [],
        attendeeEmpModels: [],
        deleteAttendeeCoModels: [],
        deleteAttendeeEmpModels: [],
        opinions: [],
        attendees: [],
        opinionlist: [],
        opinionDt: '',
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      filter: '',
      subjectGrid: {
        merge: [
          // { index: 0, colName: 'codeName' },
        ],
        columns: [
          {
            name: 'codeName',
            field: 'codeName',
            label: '심의의결사항',
            align: 'left',
            sortable: true,
          },
          // {
          //   name: 'attrVal1',
          //   field: 'attrVal1',
          //   label: '회의항목 상세',
          //   align: 'left',
          //   sortable: true,
          // },
        ]
      },
      grid: {
        merge: [
          { index: 0, colName: 'deptName' },
          { index: 1, colName: 'regUserId' },
          { index: 2, colName: 'regUserId' },
          { index: 3, colName: 'proceedingOpinionCd' },
        ],
        columns: [
          {
            name: 'deptName',
            field: 'deptName',
            label: '부서',
            align: 'center',
            style: 'width: 120px',
            sortable: true,
          },
          {
            name: 'regUserName',
            field: 'regUserName',
            label: '참석자',
            align: 'center',
            style: 'width: 200px',
            sortable: true,
          },
          {
            name: 'attendeeSignatureName',
            field: 'attendeeSignatureName',
            label: '참석여부',
            align: 'center',
            style: 'width: 100px',
            sortable: true,
          },
          {
            name: 'proceedingOpinionName1',
            field: 'proceedingOpinionName1',
            label: '심의의결사항',
            style: 'width: 500px',
            align: 'left',
            sortable: true,
          },
          // {
          //   name: 'proceedingOpinionName2',
          //   field: 'proceedingOpinionName2',
          //   label: '회의항목 상세',
          //   style: 'width: 300px',
          //   align: 'left',
          //   sortable: true,
          // },
          {
            name: 'opinionContent',
            field: 'opinionContent',
            label: '참석자 의견',
            align: 'left',
            type: 'html',
            sortable: true,
          },
        ]
      },
      inGrid: {
        columns: [
          {
            name: 'attendeeDeptName',
            field: 'attendeeDeptName',
            //부서
            label: 'LBLDEPT',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
          {
            name: 'attendeeUserName',
            field: 'attendeeUserName',
            //이름
            label: 'LBLNAME',
            style: 'width: 80px',
            align: 'center',
          },
          {
            name: 'attendeeJobName',
            field: 'attendeeJobName',
            //직책
            label: 'LBLPOSITION',
            style: 'width: 80px',
            align: 'center',
          },
          {
            name: 'remark',
            field: 'remark',
            //비고
            label: 'LBLREMARK',
            type: 'text',
            align: 'left',
            style: 'width: 200px',
          },
        ],
        height: '300px',
        data: [],
      },
    };
  },
  computed: {
    hasTargetDepts() {
      return this.opinions.attendees && this.opinions.attendees.length > 0
    },
    listCheck() {
      return this.opinions.attendeeEmpModels.length > 0 || this.opinions.attendeeCoModels.length > 0
    },
    disabled() {
      return !this.editable && this.data.proceedingStatusCd !== 'PSC0000002';
    },
    isOwner() {
      return this.$store.getters.user.deptCd == this.opinions.deptCd;
    },
    isAttend() {
      if (this.opinions.opinionlist.length > 0) {
        return this.opinions.opinionlist[0].attendeeSignatureName === '참석';
      } else {
        return false;
      }
    },
    approvalInfo() {
      return {
        sysApprovalRequestId: this.opinions.sysApprovalRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.opinions.approvalStatusCd, 
        apprEditable: !this.disabled && this.param.proceedingsId, // 결재버튼 활성화 기준
        param: this.opinions, // 결재 param
        approvalUrl: transactionConfig.sai.osh.proceedings.complete.url, // 결재 url
        isApproval: this.isApproval, // 결재 submit
        approvalTypeCd: 'APTC000020', // 결재유형코드
        approvalParamValue: { // 결재상세화면 파라미터
          proceedingsId: this.param.proceedingsId,
          isApprContent: true
        },
        approvalRequestName: '산업안전보건위원회 계획 ['+this.opinions.proceedingsTitle+']', // 결재요청명 (문서 title)
        approvalConnId: this.param.proceedingsId, // 결재연결용 업무일련번호 (문서 key)
      }
    },
    gridHeight() {
      let height = 250;
      let _margin = 600;
      height = this.contentHeight - _margin
      if (height < 250) {
        height = 250
      }
      return String(height) + 'px';
    },
    showApproval() {
      return this.editable
        && !this.disabled
        // && this.opinions.opinionlist.length === this.$_.filter(this.opinions.opinionlist, {
        //   attendeeSignatureName: '참석'
        // }).length
    },
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      
      this.opinions.proceedingsDate = this.$comm.getToday();
      // url setting
      this.detailUrl = selectConfig.sai.osh.proceedings.get.url;
      this.insertUrl = transactionConfig.sai.osh.proceedings.insert.url;
      this.updateUrl = transactionConfig.sai.osh.proceedings.update.url;
      this.deleteUrl = transactionConfig.sai.osh.proceedings.delete.url;
      this.redirectUrl = selectConfig.com.mobileHostname.url;
      this.getDetail();
    },
    getDetail() {
      if (this.param.proceedingsId) {
        this.$http.url = this.$format(this.detailUrl, this.param.proceedingsId);
        this.$http.param = {userId: this.$store.getters.user.userId, deptCd: ''}
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.opinions = _result.data;
          this.$set(this.attachInfo, 'taskKey', this.param.proceedingsId)
        },);
      }
    },
    saveDataAppr() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '결재요청 하기 전 입력된 값을 저장합니다.\n\r 진행하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.opinions.regUserId = this.$store.getters.user.userId
          this.opinions.chgUserId = this.$store.getters.user.userId

          let promises = [
            {
              func: this.approvalValue
            },
          ];
          this.$comm.orderedPromise(promises);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    // [S] 결재관련 
    approvalCallback() { // 결재관련 결재요청버튼 callback
      this.$refs['appr-btn'].apprRequestPop();
    },
    approvalValue() {
      return new Promise(resolve => {
        this.isApproval = !this.isApproval
        resolve(true);
      });
    },
  }
};
</script>
